import React, { ReactNode, createElement } from 'react';
import styled from 'styled-components';
// eslint-disable-next-line import/no-namespace
import * as ss from 'styled-system';

import TabContext from 'containers/TabContext';

type Props = {
  as?: React.ComponentType | React.ElementType;
  children?: ReactNode;
  component?: React.ComponentType | React.ElementType;
  className?: string;
  m?: string | number;
  mt?: string | number;
  mr?: string | number;
  mb?: string | number;
  ml?: string | number;
  mx?: string | number;
  my?: string | number;
  p?: string | number;
  pt?: string | number;
  pr?: string | number;
  pb?: string | number;
  pl?: string | number;
  px?: string | number;
  py?: string | number;
  display?: string;
  alignItems?: string;
  justifyContent?: string;
  width?: string | number;
  height?: string | number;
  minWidth?: string | number;
  minHeight?: string | number;
  color?: string;
  bg?: string;
  fontSize?: string;
  fontWeight?: string | number;
  borderRadius?: string | number;
  border?: string;
  borderLeft?: string;
  type?: 'submit' | 'reset' | 'button' | undefined;
  href?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: (any) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onKeyUp?: (any) => any;
  title?: string;
  tabIndex?: number;
  name?: string;
  disabled?: boolean;
};

const StyledButton = styled(
  ({
    as,
    component,
    type = 'button',
    isTabbing,
    m,
    mt,
    mr,
    mb,
    ml,
    mx,
    my,
    p,
    pt,
    pr,
    pb,
    pl,
    px,
    py,
    display,
    alignItems,
    justifyContent,
    width,
    height,
    minWidth,
    minHeight,
    color,
    bg,
    fontSize,
    fontWeight,
    borderRadius,
    border,
    ...props
  }: Props & { isTabbing: boolean }) => {
    if (as) {
      return createElement(as, props);
    }
    if (component) {
      return createElement(component, props);
    }
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading, react/button-has-type
    return <button {...props} type={type} />;
  }
)`
  padding: 0;
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  &[disabled] {
    cursor: auto;
  }
  ${(props) =>
    !props.isTabbing &&
    `
    outline: 0;
  `}
  ${ss.size} ${ss.display} ${ss.space} ${ss.width} ${ss.height} ${ss.minWidth} ${ss.minHeight} ${ss.fontSize} ${ss.fontWeight} ${ss.borderRadius} ${ss.color} ${ss.border}
`;

export function Button(props: Props) {
  return (
    <TabContext.Consumer>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      {(isTabbing) => <StyledButton {...props} isTabbing={isTabbing} />}
    </TabContext.Consumer>
  );
}
